import { Form, Radio } from "antd";
import Search from "antd/es/input/Search";
import styled from "styled-components";

export const StyledRadioBtn = styled(Radio.Button)`
    font-size: 13px;
`;

export const StyledFormItem = styled(Form.Item)`
    margin: 0;
    width: 100%;
`;

export const StyledSearch = styled(Search)`
    width: 100%;

    background-color: red;
`;

export const StyledForm = styled(Form)`
    margin-bottom: 15px;
` as typeof Form;

export const StyledFormItemRadio = styled(StyledFormItem)`
    display: flex;
    justify-content: center;
`;
